function ChevronRight({ style }) {
  const { fill = '#9191A8', width = 24, height = 24 } = style || {};
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m10 7 3.92 4.764a.346.346 0 0 1 .06.109.395.395 0 0 1-.06.363L10 17"
      />
    </svg>
  );
}

export default ChevronRight;
